module.exports = __webpack_public_path__ + "img/login_logo.384f5475.png";